// extracted by mini-css-extract-plugin
export default {"container":"DisplaySettings_container__MN7hF","popup":"DisplaySettings_popup__2rWuw","dropdown":"DisplaySettings_dropdown__WaZBY","textarea":"DisplaySettings_textarea__xIE0l"};